import { Section, Eyebrow, Heading, Cta } from './home-ui';

// Accepts the servicesData shape (cardTitle/cardDescription/icon/slug) OR the
// lightweight {title,text,icon,slug} mock shape.
export default function Services({ data, meta }) {
    const cards = data || [];
    if (!cards.length) return null;
    const m = meta || { eyebrow: 'Services', titleLine1: 'Focused services,', titleLine2: 'not endless clutter.' };

    return (
        <Section id="services" bg="alt">
            <div className="mx-auto max-w-2xl text-center">
                {m.eyebrow && <div className="flex justify-center"><Eyebrow>{m.eyebrow}</Eyebrow></div>}
                <Heading line1={m.titleLine1} line2={m.titleLine2} className="mt-4" />
                {m.paragraph && <p className="mt-4 text-lg text-ink-muted">{m.paragraph}</p>}
            </div>

            <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
                {cards.map((s) => (
                    <div key={s.slug || s.cardTitle || s.title}
                        className="group rounded-card border border-surface-line bg-white p-6 transition hover:border-brand hover:shadow-[0_10px_30px_rgba(11,34,101,0.09)]">
                        <div className="flex h-12 w-12 items-center justify-center rounded-field bg-navy text-2xl text-white">{s.icon}</div>
                        <h3 className="mt-5 font-display text-xl font-bold text-navy">{s.cardTitle || s.title || s.name}</h3>
                        <p className="mt-2 text-ink-muted">{s.cardDescription || s.text}</p>
                    </div>
                ))}
            </div>

            <div className="mt-10 flex justify-center">
                <Cta label="Start Free Review" href="#contact" />
            </div>
        </Section>
    );
}
